import { useEffect, useRef, useState } from 'react';

export const useMenuRef = <RefType extends HTMLElement>() => {
  const ref = useRef<RefType>(null);
  const [isOpen, setOpen] = useState(false);

  // todo ref, isOpen을 사용하는 hook 추가
  useEffect(() => {
    const closeIfClickedOutside = (e: MouseEvent) => {
      if (isOpen && ref.current && !ref.current?.contains(e.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', closeIfClickedOutside);

    return () => document.removeEventListener('mousedown', closeIfClickedOutside);
  }, [isOpen]);

  return { ref, isOpen, setOpen };
};
